import { render, staticRenderFns } from "./AppWebhook.vue?vue&type=template&id=23e485ce&scoped=true&"
import script from "./AppWebhook.vue?vue&type=script&lang=js&"
export * from "./AppWebhook.vue?vue&type=script&lang=js&"
import style0 from "./AppWebhook.vue?vue&type=style&index=0&id=23e485ce&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23e485ce",
  null
  
)

export default component.exports